import { motion } from 'motion/react';
import { useGetParams } from '../../hooks/useGetParams';

import styles from './Advt.module.css';

import logo from '../../assets/images/logo.png';

export const Advt = ({}) => {
  const { title } = useGetParams();

  const titleArr = title.split(/\\n/);

  return (
    <motion.div
      initial={{ y: '-100%' }}
      animate={{ y: 0, transition: { duration: 0.5 } }}
      exit={{ y: '-100%', transition: { duration: 0.5, delay: 0.5 } }}
      className={styles.advtBlock}
    >
      <img src={logo} alt="" />
      <div className={styles.advtTitle}>
        {titleArr[0] && (
          <div className={styles.firstLineTitle}>{titleArr[0]}</div>
        )}
        {titleArr[1] && (
          <div className={styles.secondLineTitle}>{titleArr[1]}</div>
        )}
      </div>
    </motion.div>
  );
};
